import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/jsx-pascal-case */
import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Themed } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'button'
});
/**
 * The **Button** component is used to trigger an action or event, such as submitting a form, opening a dialog, canceling an action, or performing a delete operation.
 *
 */

export var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      disabled = _ref.disabled,
      size = _ref.size,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      children = _ref.children,
      as = _ref.as,
      fullWidth = _ref.fullWidth,
      props = _objectWithoutProperties(_ref, ["variant", "disabled", "size", "leftIcon", "rightIcon", "children", "as", "fullWidth"]);

  return _jsxs(Themed.div, _objectSpread(_objectSpread({
    as: as,
    disabled: disabled,
    sx: {
      variant: variantPath(variant),
      width: fullWidth ? '100%' : undefined,
      m: 0,
      p: size === 'small' ? 'xs' : 'base',
      fontSize: size === 'small' ? 'xxs' : 'base',
      cursor: !disabled ? 'pointer' : 'not-allowed',
      // make icons align
      'img,svg': {
        display: 'block'
      },
      '&:visited': {
        textDecoration: 'inherit',
        variant: variantPath(variant)
      },
      '&:hover, ._force-hover &': {
        variant: variantPath(variant, 'hover')
      },
      '&:focus, ._force-focus &': {
        variant: variantPath(variant, 'focus')
      },
      '&:active, ._force-active &': {
        variant: variantPath(variant, 'active')
      },
      '&:disabled, ._force-disabled &': {
        variant: variantPath(variant, 'disabled')
      }
    },
    ref: ref
  }, props), {}, {
    children: [leftIcon ? _jsx("div", {
      sx: {
        mr: 'xs'
      },
      children: leftIcon
    }) : null, children, rightIcon ? _jsx("div", {
      sx: {
        ml: 'xs'
      },
      children: rightIcon
    }) : null]
  }));
});
Button.propTypes = {
  /**
   * Which variant?
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

  /**
   * Show the button is unable to be used
   */
  disabled: PropTypes.bool,

  /**
   * Show button sizes
   */
  size: PropTypes.oneOf(['small', 'large']),

  /**
   * Show left icon button
   */
  leftIcon: PropTypes.element,

  /**
   * Show right icon button
   */
  rightIcon: PropTypes.element,

  /**
   * The of element to use
   */
  as: PropTypes.elementType,

  /**
   * Make the element the full width of its parent
   */
  fullWidth: PropTypes.bool
};
Button.defaultProps = {
  variant: 'primary',
  disabled: false,
  size: 'large',
  as: 'button',
  fullWidth: false
};
Button.displayName = 'Button';